module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "visible": _vm.showAdminModal === 'addEditRole',
      "size": "lg",
      "lazy": true
    },
    on: {
      "hidden": _vm.hideModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [(_vm.item) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Изменить роль " + _vm._s(_vm.item.name))]) : _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Добавить роль")])]), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Сохраняем..."
    }
  }) : _c('form', {
    attrs: {
      "сlass": "form-horizontal"
    }
  }, [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newDataItem.name.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "item-name"
    }
  }, [_vm._v("Название (код)")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.name),
      expression: "newDataItem.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "item-name"
    },
    domProps: {
      "value": (_vm.newDataItem.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "name", $event.target.value.trim())
      }, function($event) {
        _vm.$v.newDataItem.name.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.newDataItem.name.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Название обязательно должно быть указано латиницей, минимум " + _vm._s(_vm.$v.newDataItem.name.$params.minLength.min) + " символа")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "item-sort"
    }
  }, [_vm._v("Описание")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.description),
      expression: "newDataItem.description",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "item-sort"
    },
    domProps: {
      "value": (_vm.newDataItem.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "description", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label"
  }, [_vm._v("Пользователи")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.users,
      "searchable": true,
      "multiple": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Пользователи не заданы",
      "track-by": "id",
      "label": "fullname",
      "loading": _vm.loadingUsers
    },
    on: {
      "select": _vm.attachUser,
      "remove": _vm.detachUser,
      "open": _vm.loadUsers
    },
    model: {
      value: (_vm.selectedUsers),
      callback: function($$v) {
        _vm.selectedUsers = $$v
      },
      expression: "selectedUsers"
    }
  })], 1)]), _vm._v(" "), (_vm.loadingPermissions) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Загружаем права доступа..."
    }
  }) : _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Права доступа")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, _vm._l((_vm.permissions), function(permission) {
    return _c('div', [_c('label', {
      staticClass: "switch switch-lg switch-3d switch-primary mb-2 mr-1"
    }, [_c('input', {
      staticClass: "switch-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": _vm.newDataItem.permissions.indexOf(permission.id) !== -1,
        "checked": _vm.newDataItem.permissions.indexOf(permission.id) !== -1
      },
      on: {
        "change": function($event) {
          _vm.changePermission(_vm.newDataItem.permissions.indexOf(permission.id), permission.id)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "switch-label"
    }), _vm._v(" "), _c('span', {
      staticClass: "switch-handle"
    })]), _vm._v("\n                    " + _vm._s(permission.description) + "\n                ")])
  }))])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.loading && !_vm.loadingPermissions) ? _c('button', {
    staticClass: "btn btn-success",
    class: {
      'disabled': _vm.$v.newDataItem.$invalid
    },
    attrs: {
      "disabled": _vm.$v.newDataItem.$invalid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.beforeUpdateForm($event)
      }
    }
  }, [(_vm.item) ? [_vm._v("Сохранить изменения")] : [_vm._v("Добавить роль")]], 2) : _vm._e()])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-50378596", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-50378596"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/ModalAdminAddEditRole.vue
// module id = 1037
// module chunks = 1